export default {"src":"/_next/static/media/icn.bf8e4600.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};